import { colorConstants } from 'config/colorConstants';
import React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const NegativeTriangle = ({ stroke = colorConstants.red }: { stroke?: string }) => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.60847 7.5L8.82026 0.75H0.396683L4.60847 7.5Z" fill={stroke} />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.60847 7.5L8.82026 0.75H0.396683L4.60847 7.5Z" fill={stroke} />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width="9" height="8" viewBox="0 0 9 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.60847 7.5L8.82026 0.75H0.396683L4.60847 7.5Z" fill={stroke} />
        </svg>
    );
};

export default NegativeTriangle;
